
const WebIcon1 = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5 7.18896C17.2201 8.50516 14.6325 9.19474 12 9.18771C9.36745 9.19474 6.77991 8.50516 4.5 7.18896" stroke="#0069AD" />
            <path d="M11.5 15H8.5L9 17.5L9.5 19.5L11 21H13.5L14.5 18.5L15.5 15.5L11.5 15Z" fill="#BBD8ED" />
            <path d="M4.5 16.8301C6.77672 15.5191 9.35782 14.8291 11.985 14.8291C14.6122 14.8291 17.1933 15.5191 19.47 16.8301" stroke="#0069AD" />
            <path d="M10.875 21C8.92767 18.4036 7.875 15.2456 7.875 12C7.875 8.75445 8.92767 5.59644 10.875 3" stroke="#00A7E4" />
            <path d="M13.125 3C15.0723 5.59644 16.125 8.75445 16.125 12C16.125 15.2456 15.0723 18.4036 13.125 21" stroke="#00A7E4" />
            <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#0069AD" />
        </svg>
    )
}

export default WebIcon1